<template>
  <div class="bill">
    <div class="bill-top">
      <div class="scRadio">
        <div class="scRadio-item" :class="{'scRadio-item-a':activeName=='money'}" @click="getTab('money')">余额明细</div>
        <div class="scRadio-item" :class="{'scRadio-item-a':activeName=='skin'}" @click="getTab('skin')">饰品明细</div>
        <div class="scRadio-item" :class="{'scRadio-item-a':activeName=='charge'}" @click="getTab('charge')">充值记录</div>
      </div>
    </div>
    <div class="bill-warp">
      <div class="hist-list">
        <div class="csgo-table">
          <el-table v-if="activeName=='money'" :data="list" border style="width: 100%">
            <el-table-column prop="message" label="描述" />
            <el-table-column prop="pay" label="类型" width="70" align="center">
              <template slot-scope="scope">
                <div v-if="scope.row.type>0" style="color:#02bf4d;">收入</div>
                <div v-else>支出</div>
              </template>
            </el-table-column>
            <el-table-column prop="amount" label="金额">
              <template slot-scope="scope">
                <div v-if="scope.row.amount" class="flex flex-ac">
                  <img src="@/assets/images/money.png" class="money-img" />
                  <span>{{ scope.row.amount }}</span>
                </div>
                <div v-if="scope.row.masonry" class="flex flex-ac">
                  <img src="@/assets/images/masonry.png" class="masonry-img" />
                  <span>{{ scope.row.masonry }}</span>
                </div>
              </template>
            </el-table-column>
            <el-table-column prop="create_time" label="时间" />
            <!-- <el-table-column prop="total_amount" label="余额">
            </el-table-column> -->
          </el-table>
          <el-table v-else-if="activeName == 'skin'" :data="skinList" border style="width: 100%">
            <el-table-column prop="skin_name" label="饰品名称">
              <template slot-scope="scope">
                <div :style="'color:'+ scope.row.rarityColor">{{ scope.row.skin_name }}</div>
              </template>
            </el-table-column>
            <el-table-column prop="source" label="来源" width="100" align="center" />
            <el-table-column prop="status" label="状态" width="80" align="center" />
            <el-table-column prop="time" label="时间" width="160" />
            <!-- <el-table-column prop="create_time" label="状态" width="180" /> -->
          </el-table>
          <el-table v-else :data="tableData" border style="width: 100%">
            <el-table-column prop="create_time" label="日期">
            </el-table-column>
            <el-table-column prop="modeName" label="充值方式">
            </el-table-column>
            <el-table-column prop="coin" label="充值金币">
            </el-table-column>
            <el-table-column prop="statusName" label="充值结果">
            </el-table-column>
          </el-table>
        </div>
        <div class="csgo-page">
          <el-pagination background layout="prev, pager, next" :current-page.sync="searchForm.page" :total="searchForm.totalSize" :page-size="searchForm.limit" @current-change="currentChange">
          </el-pagination>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      searchForm: {
        page: 1,
        totalSize: 0,
        limit: 20,
        status: 1
      },
      list: [],
      skinList: [],
      activeName: "money",
      tableData: [],
      totalSize: 0,
      pageSize: 20
    };
  },
  created() {
    this.getList()
  },
  methods: {
    getTab(tab) {
      if (this.activeName == tab) return false
      this.list = []
      this.skinList = []
      this.searchForm.page = 1
      this.activeName = tab
      this.getList()
    },
    getList(page) {
      if (this.activeName != 'charge') {
        this.$doGet(this.activeName == 'money' ? "/api/member.Balance/list" : '/api/member.SkinBackpack/myJewelryDetails', this.searchForm).then((res) => {
          if (this.activeName == 'money') {
            this.list = res.data.list
          } else {
            this.skinList = res.data.list
          }
          this.searchForm.totalSize = res.data.count
        }).catch(() => {
        })
      } else {
        this.$doGet("/api/member.Recharge/list", {
          page: page,
          limit: this.pageSize
        }).then((res) => {
          this.totalSize = res.data.count
          this.tableData = res.data.list;
          for (let i = 0; i < this.tableData.length; i++) {
            if (this.tableData[i].mode == "zhifubao") {
              this.tableData[i].modeName = "支付宝";
            } else if (this.tableData[i].mode == "jdpay") {
              this.tableData[i].modeName = "CDK";
            } else {
              this.tableData[i].modeName = "微信";
            }
            if (this.tableData[i].status == 1) {
              this.tableData[i].statusName = "未支付";
            } else if (this.tableData[i].status == 2) {
              this.tableData[i].statusName = "待支付";
            } else if (this.tableData[i].status == 3) {
              this.tableData[i].statusName = "支付成功";
            } else {
              this.tableData[i].statusName = "支付失败";
            }
          }
        }).catch(() => { })
      }
    },
    currentChange(val) {
      this.searchForm.page = val
      this.getList()
    }
  },
};
</script>

<style lang="less" scoped>
.bill {
  .bill-top {
    text-align: center;
    padding: 36px 0 24px;
  }
  .bill-warp {
    padding: 0 15px 15px;
  }
  .roomleft-num {
    display: flex;
    align-items: center;
    justify-content: space-between;

    h5 {
      font-size: 20px;
      font-weight: 400;
      color: #c3c3e2;
    }
    h6 {
      font-weight: 200;
      color: #848492;
      font-size: 16px;

      span {
        color: #17b4ed;
      }
      span:hover {
        cursor: pointer;
        text-decoration: underline;
      }
    }
  }
}
</style>

